import Vue from 'vue'

const Categories = {
  namespaced: true,

  state: {
    category: {},
    categoryName: null,
    categories: []
  },

  mutations: {
    setCategories(state, categories) {
      state.categories = categories || []
    },
    setCategory(state, category) {
      state.category = category || {}
      state.categoryName = state.category.name
    }
  },

  actions: {
    async getAll({ commit }, { search } = {}) {
      const params = { search }
      const response = await Vue.axios.get('/categories', { params })
      const categories = response.data.data
      commit('setCategories', categories)
      return categories
    },
    async get({ commit }, id) {
      let category = { tags: { included: [], excluded: [] } }
      if (id) {
        const response = await Vue.axios.get(`/category/${id}`)
        category = response.data.data
      }
      commit('setCategory', category)
      return category
    },
    async createAndAdd({ dispatch }, { name, categories }) {
      const response = await Vue.axios.post('/category', { name })
      const { id } = response.data.data
      await dispatch('getAll')
      categories.push(id)
    },
    async createOrUpdate({ commit, state }) {
      let response
      if (state.category.id) {
        response = await Vue.axios.put(`/category/${state.category.id}`, state.category)
      } else {
        response = await Vue.axios.post('/category', state.category)
      }
      commit('setCategory', response.data.data)
    }
  }
}

export default Categories
